import React, { useEffect, useState } from 'react'
import { Tooltip, IconButton, Typography, Box, Collapse, Snackbar, Card, Alert } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useDispatch, useSelector } from 'react-redux'
import { selectQuestionById, SaveAnswer, selectQuestions, selectNextVisibleQuestion, questionSaveModify, questionBranchingLogicModify } from '../../../reducers/survey_question'
import AnswerContainer from './AnswerContainer'
import { questionsetAnswerSaved } from '../../../reducers/survey_questionset';
import axios from 'axios';
// import { calcProcess} from '../../../reducers/survey_calc';
// import QuestionSnacks from './QuestionSnacks';
/**
 * 
 
questions={quizState.Questions}
authtoken={currentUser.AuthToken}
responseguid={quizState.ResponseGuid}
startfromBeginning={quizState.StartFromBeginning}
uom={quizState.UnitOfMeasure}
validationMessages={ValidationMessages}
questionPrompts={QuestionPrompts}
updateQuestionTotal={updateQuestionTotal}
updateQuestionsAnswered={updateQuestionsAnswered}
setCurrentIndex={setCurrentIndex} 
completeSuccessful={completeSuccessful}/>
*/


const QuestionItem = (props) => {
    const QuestionId = props.Question.QuestionId
    const Question = useSelector((state) => selectQuestionById(state, QuestionId))
    const Questions = useSelector((state) => selectQuestions(state)).sort((a, b) => a.QuestionSetSequence - b.QuestionSetSequence || a.QuestionSequence - b.QuestionSequence)
    const { user: currentUser } = useSelector((state) => state.auth);
    const QuestionSetHasContent = props.QuestionSetHasContent
    const QuestionIsDisplayed = Question.QuestionDisplayedFlag === "1" ? true : false
    const { settings } = useSelector(state => state.viewinstance)

    


    const dispatch = useDispatch()
    useEffect(() => {

    }, [props, Question])

 

    const saveAnswer = (value) => {
        if (props.UseSaveAnswerOverride === true) {
            props.SaveAnswerOverride({ Question: Question, value: value })
        }
        else {
            saveAnswerCall({
                auth: currentUser.AuthToken,
                response: props.responseGuid,
                questionID: QuestionId,
                value: value
            }).then(responseData => {
                // console.log(responseData)
                let changes = []
                if (responseData.Info.length) {
                    if (responseData.Info[0].Changes) {

                        responseData.Info[0].Changes.forEach((question) => {
                            changes[question.QuestionId] = question
                            dispatch(questionBranchingLogicModify({ QuestionId: question.QuestionId, QuestionDisplayedFlag: question.DisplayFlag, QuestionRequiredFlag: question.RequiredFlag }))
                        })
                    }
                    // if (responseData.Info[0].Calc) {
                    //     dispatch(calcProcess({Calc:responseData.Info[0].Calc, Source:QuestionId}))
                    // }
                    // if (responseData.Info.length > 1 && responseData.Info[1].Calc) {
                    //     dispatch(calcProcess({Calc:responseData.Info[1].Calc, Source:QuestionId}))
                    // }

                }

                dispatch(questionSaveModify({ QuestionId: QuestionId, value: value }))
                dispatch(questionsetAnswerSaved({ QuestionSetId: props.QuestionSetId }))
                if (settings.OrganizationSettingValues["WC HRA AUTOSCROLL ENABLED"] && settings.OrganizationSettingValues["WC HRA AUTOSCROLL ENABLED"] === "1") setTimeout(scrollToNextVisible(findNextVisible(changes)), 200)
            })



        }
    }

    const saveAnswerCall = async (incomingVariable) => {
        const response = await axios.post('../../WsWebServiceHra/SaveAnswer/' + incomingVariable.auth + '/' + incomingVariable.response + '/' + incomingVariable.questionID + '/' + incomingVariable.value + '/')
        const data = await response.data

        return data
    }

    const findNextVisible = (changes) => {
        //console.log(changes)
        for (let i = Questions.findIndex(question => question.QuestionId == QuestionId) + 1; i < Questions.length; i++) {

            if (changes.length) {
                //case for shoud be hidden, change = display 0
                if (changes[Questions[i].QuestionId] && changes[Questions[i].QuestionId].DisplayFlag === "0") {
                    continue;
                }
                //case for should be seen, change = display 1
                if (changes[Questions[i].QuestionId] && changes[Questions[i].QuestionId].DisplayFlag === "1") {
                    return Questions[i];
                }
            }
            if (Questions[i] && Questions[i].QuestionDisplayedFlag === "1") {
                return Questions[i]
            }
        }
        return null
    }

    const scrollToNextVisible = (NextQuestion) => {
        if (NextQuestion && NextQuestion.QuestionSetId != Question.QuestionSetId) {
            let element = document.getElementById("QS_" + NextQuestion.QuestionSetId);
            if (element) {
                element.scrollIntoView({
                    block: element.offsetHeight > window.innerHeight ? "start" : "center",
                    behavior: "smooth"
                });
            }
        }

    }

    let helpIcon = <Tooltip enterTouchDelay={10} title={<span dangerouslySetInnerHTML={{ __html: Question.QuestionHelpText }}></span>}>
        <IconButton>
            <HelpOutlineIcon fontSize="small" />
        </IconButton>
    </Tooltip>

    return (
        <Box display={QuestionIsDisplayed ? 'block' : 'none'} m={QuestionIsDisplayed ? 0 : -4} id={"Q_" + QuestionId} mb={QuestionIsDisplayed ? 2 : 0}>
            <Collapse in={QuestionIsDisplayed} timeout="150" unmountOnExit >
                {Question.QuestionTypeKeyName !== 'CHECKBOX' && (<Typography variant={QuestionSetHasContent ? "h6" : "body1"}>{Question.QuestionStandardContent} {Question.QuestionHelpText ? helpIcon : ''}</Typography>)}
                <AnswerContainer saveAnswer={saveAnswer} {...Question} QuestionSetHasContent={QuestionSetHasContent} QuestionStandardContent={Question.QuestionStandardContent} />
                {/* <QuestionSnacks QuestionName={Question.QuestionName} QuestionId={QuestionId}/> */}
            </Collapse>
        </Box>
    )

}

export default QuestionItem